<div class="d-flex justify-content-between mb-4">
  @if(center()) {
    <span></span>
  }
  <h2 class="text-truncate">
    @let tmplIcon = icon();
    @if (tmplIcon) {
      <fa-icon [icon]=tmplIcon></fa-icon> {{title()}}
    }
  </h2>
  <div class="ms-3 me-1">
    <button (click)="navigateBack()" type="button" class="btn btn-outline-dark">
      <fa-icon [icon]=faLevelUpAlt rotate="270"></fa-icon>
      <span class="ms-1 d-none d-md-inline"> terug</span>
    </button>
  </div>
</div>